import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { GetKaroakeListRequest } from './getkaroakelistrequest';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class GetKaroakeListAPI extends SixdeeCRBTAPI<GetKaroakeListRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/get-karoake-list
        return "get-karoake-list";
    }

    getRequestData()
    {
        return "clientTxnId=17062020"+"&"+
               "serviceId=" + this.getRequest().getKaroakeListRequest().getServiceId() +"&"+
               "aPartyMsisdn=" + this.getRequest().getKaroakeListRequest().getAPartyMsisdn() +"&"+
               "channelId="+ this.getRequest().getKaroakeListRequest().getChannelId()+"&"+
               "language="+ (this.getRequest().getKaroakeListRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2");
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/karoake/getkaroakelist/getkaroakelistapi.tsx